import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-entry-bucket',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLink,
    RouterModule,
    TranslateModule,
  ],
  templateUrl: './entry-bucket.component.html',
  styleUrl: './entry-bucket.component.css'
})
export class EntryBucketComponent {
  @Input() disabled: boolean = false;
  @Input() targetRoute: string = "";
  @Input() imagePath: string = "";
  @Input() iconName: string = "";
  @Input() label: string = "";
  @Output() clicked = new EventEmitter();

  onClick = () => this.clicked.emit();
}
